import { Alert, Snackbar } from "@mui/material";
import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setState } from "./reviewSlice";
import { Stack} from "@mui/material";

export default function MessageForModification() {
	const dispatch = useDispatch();
	const setupState = useSelector((store) => store.review);
	const { message,secondMessage, severity, messageOpen, secondMessageOpen, secondSeverity } = setupState;
	const handleCloseSnackbar = () => {
		dispatch(setState("messageOpen", false));
	};
	const handleCloseSnackbarSecond = () => {
		dispatch(setState("secondMessageOpen", false));
	};

	return (
		<div>
		<Snackbar spacing= {2}
			anchorOrigin={{ vertical: "top", horizontal: "right" }}
			open={messageOpen}
			autoHideDuration={5000}
			onClose={handleCloseSnackbar}
		>
			<Alert
				onClose={handleCloseSnackbar}
				severity={severity}
				sx={{ width: "100%" }}
			>
				{typeof message === "object" ? "Successfull" : message}
			</Alert>
		</Snackbar>
		{secondMessage !== "" && (
		<Snackbar
				anchorOrigin={{ vertical: "top", horizontal: "right" }}
				sx ={{marginTop: "50px"}}
				open={secondMessageOpen}
				autoHideDuration={5000}
				onClose={handleCloseSnackbarSecond}
			>
				<Alert
					onClose={handleCloseSnackbarSecond}
					severity={secondSeverity}
					sx={{ width: "100%" }}
				>
					{typeof secondMessage === "object" ? "Successfull" : secondMessage}
				</Alert>
			</Snackbar>
			)}
			</div>
	);
}
